import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './components/Brand';
import ThemeToggle from './components/ThemeToggle';

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-surface text-content">
      {/* Simple Navigation */}
      <nav className="bg-surface-2 border-b border-line sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-[72px]">
            <Brand />
            <div className="flex items-center gap-4">
              <Link to="/" className="text-content-2 hover:text-accent transition">
                ← Back to Home
              </Link>
              <ThemeToggle />
            </div>
          </div>
        </div>
      </nav>

      {/* Privacy Policy Content */}
      <section className="py-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-content mb-4">Privacy Policy</h1>
            <p className="text-xl text-content-2">Your privacy is our priority</p>
          </div>
          
          <div className="bg-surface-2 rounded-2xl p-8 border border-line">
            <h2 className="text-2xl font-bold text-content mb-6">Our Commitment to Your Privacy</h2>
            
            <div className="space-y-4 text-content-2">
              <p className="text-lg font-semibold text-accent">
                We do not share your information with anyone, ever.
              </p>
              
              <p>
                At Databurst Technologies LLC, we take your privacy seriously. Any information you provide to us through our website, 
                contact forms, or consultations is kept strictly confidential.
              </p>
              
              <h3 className="text-xl font-semibold text-content mt-6 mb-3">What We Collect</h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Contact information (name, email, phone) only when you provide it</li>
                <li>Company information for business inquiries</li>
                <li>Project details you choose to share with us</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-content mt-6 mb-3">What We Don't Do</h3>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>We never sell your data</li>
                <li>We never share your information with third parties</li>
                <li>We never use your data for marketing without consent</li>
                <li>We never store payment information on our servers</li>
              </ul>
              
              <h3 className="text-xl font-semibold text-content mt-6 mb-3">Your Rights</h3>
              <p>
                You have the right to request access to, correction of, or deletion of your personal information at any time. 
                Simply contact us at privacy@databurst.dev.
              </p>
              
              <p className="mt-6 pt-6 border-t border-line text-sm text-content-2">
                Last updated: January 2025
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Simple Footer */}
      <footer className="bg-surface-2 text-content py-8 mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-content-2">
            © 2017-2026 Databurst Technologies LLC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;